// djin-cloud/web/src/hooks/useEnergyProfile.ts

import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

export function useEnergyProfile(
  siteId: string,
  range: string,
  customStart?: string,
  customEnd?: string,
) {
  const params: Record<string, string> = { range };
  if (range === 'custom' && customStart && customEnd) {
    params.start = customStart;
    params.end = customEnd;
  }

  return useQuery({
    queryKey: ['energy-profile', siteId, range, customStart, customEnd],
    queryFn: () =>
      api.get(`/v1/sites/${siteId}/energy-profile`, { params }).then((r) => r.data.data),
    enabled: Boolean(siteId),
    staleTime: 5 * 60 * 1000,
  });
}
